import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from 'vue';
  import VueSlider from 'vue-slider-component';
  import 'vue-slider-component/theme/default.css';

  
  const __default__ = {
    name: 'BaseSlider',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: { type: Number, required: false, default: 100 },
    interval: { type: Number, required: false, default: 1 },
    min: { type: Number, required: false, default: 0 },
    max: { type: Number, required: false, default: 100 },
    disabled: { type: Boolean, required: false, default: false }
  },
  emits: ["update:value"],
  setup(__props: any, { emit }: { emit: ({ (event: 'update:value', value: number): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { value: number, interval: number, min: number, max: number, disabled: boolean };

  
  const { value, interval, min, max, disabled } = toRefs(props);

  

  const sliderStyle = computed(() => {
    return {
      baseLine: { backgroundColor: '#F0F0F0', borderRadius: 0, marginLeft: '6px' },
      valueLine: { backgroundColor: '#E3003A', borderRadius: 0 },
      dot: {
        backgroundColor: '#E3003A',
        border: '2px solid white',
        boxShadow: 'none',
        marginTop: '-4px',
        height: '22px',
        width: '22px',
      },
    };
  });

  function handleChange(value: number) {
    emit('update:value', value);
  }

return { __sfc: true,props, value, interval, min, max, disabled, emit, sliderStyle, handleChange, VueSlider }
}

})